import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import * as S from './styles';
import { getDescriptionRepresentation, isEmptyDescription } from './parseUtils';

const sanitizedDescription = description => {
    const html = getDescriptionRepresentation(description);
    // eslint-disable-next-line react/no-danger
    return <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
};

const getDescriptionListHtml = descriptionList =>
    descriptionList.map(({ text, title }, index) => {
        return (
            <div key={index} className="mt-16">
                {index !== 0 && <h4>{title}</h4>}
                {sanitizedDescription(text)}
            </div>
        );
    });

const getDescriptionHtml = description => {
    if (isEmptyDescription(description)) return <p>Mer informasjon kommer</p>;
    if (typeof description === 'string') return sanitizedDescription(description);
    return getDescriptionListHtml(description);
};

const AdDescription = ({ description }) => {
    return (
        <div>
            <h3>Beskrivelse</h3>

            <S.DescriptionText className="mb-16">{getDescriptionHtml(description)}</S.DescriptionText>
        </div>
    );
};

AdDescription.propTypes = {
    description: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                title: PropTypes.string,
            })
        ),
        PropTypes.string,
    ]),
};

export default AdDescription;
